"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const next13_enums_colors_1 = __importDefault(require("@gerenciatd/next13.enums.colors"));
const InformacionIconM = (props) => {
    let { color } = props;
    let layoutSize = {};
    if (props.layoutSize) {
        ({ layoutSize } = props);
    }
    let { width, height, insetPosition } = props;
    const size = {};
    /* damos valor a la otra coordenada en caso de no indicarse */
    if (width && width !== "auto") {
        if (!layoutSize.width) {
            layoutSize.width = width;
        }
        size.width = width;
    }
    if (height && height !== "auto") {
        if (!layoutSize.height) {
            layoutSize.height = height;
        }
        size.height = height;
    }
    const fill = (0, next13_enums_colors_1.default)(color);
    return (react_1.default.createElement("div", { className: "svg-layout-size", style: Object.assign({}, layoutSize) },
        react_1.default.createElement("svg", Object.assign({ focusable: "false", viewBox: "0 0 200 200", "aria-label": true, "aria-hidden": "true", role: "presentation" }, size, { style: Object.assign({}, insetPosition), fill: fill }),
            react_1.default.createElement("path", { d: "M100 199.5c-31.6 0-56.2-8.3-73.1-24.6C9.4 158 .5 132.8.5 100s8.9-58 26.4-74.9C43.8 8.8 68.4.5 100 .5s56.2 8.3 73.1 24.6c17.5 16.9 26.4 42.1 26.4 74.9s-8.9 58-26.4 74.9c-16.9 16.3-41.5 24.6-73.1 24.6m0-187.7c-28.5 0-50.5 7.2-65.2 21.4-15.2 14.7-23 37.2-23 66.8s7.7 52.1 23 66.8c14.7 14.2 36.7 21.4 65.2 21.4s50.5-7.2 65.2-21.4c15.2-14.7 23-37.2 23-66.8s-7.7-52.1-23-66.8C150.5 19 128.5 11.8 100 11.8" }),
            react_1.default.createElement("path", { d: "M99.9 149.9c-3.1 0-5.7-2.5-5.7-5.7V77.8c0-3.1 2.5-5.7 5.7-5.7s5.7 2.5 5.7 5.7v66.4c0 3.2-2.6 5.7-5.7 5.7" }),
            react_1.default.createElement("path", { d: "M105.8 55.6c0-3.1-2.5-5.7-5.7-5.7-3.1 0-5.7 2.5-5.7 5.7 0 3.1 2.5 5.7 5.7 5.7 3.1-.1 5.7-2.6 5.7-5.7" }))));
};
exports.default = InformacionIconM;
//# sourceMappingURL=index.js.map